import React from 'react';
import { ShieldCheck, UserCheck, Eye } from 'lucide-react';
import { FAIRNESS_RULES } from '../mock';
import FadeInSection from './FadeInSection';
import SafeMotion from './SafeMotion';

const RuleIcon = ({ name }) => {
  const cls = 'w-5 h-5';
  if (name === 'shield') return <ShieldCheck className={cls} />;
  if (name === 'user-check') return <UserCheck className={cls} />;
  if (name === 'eye') return <Eye className={cls} />;
  return null;
};

export default function Fairness() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        <FadeInSection className="text-center max-w-3xl mx-auto">
          <h2 className="font-display font-extrabold text-white text-4xl md:text-[52px] leading-[1.05] tracking-tight">
            Safe, transparent,
            <br />
            <span className="text-orange-gradient">professional trading.</span>
          </h2>
          <p className="mt-5 text-[#f2f2f2] text-[15px]">
            We ensure a 100% fair environment for every participant by enforcing strict system rules.
          </p>
        </FadeInSection>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {FAIRNESS_RULES.map((r, i) => (
            <SafeMotion
              key={r.title}
              initial={{ filter: 'blur(10px)', opacity: 0, y: 30 }}
              whileInView={{ filter: 'blur(0px)', opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1, margin: '0px 0px -80px 0px' }}
              transition={{ duration: 0.7, ease: 'easeOut', delay: i * 0.12 }}
              className="card-dark p-6"
            >
              <div className="icon-badge"><RuleIcon name={r.icon} /></div>
              <div className="mt-5 text-white font-semibold text-lg uppercase tracking-wide">{r.title}</div>
              <p className="mt-2 text-[#f2f2f2] text-[13.5px] leading-relaxed">{r.desc}</p>
            </SafeMotion>
          ))}
        </div>
      </div>
    </section>
  );
}
